module.exports = __webpack_public_path__ + "img/SAVE.f6ee179c.svg";